import CustomizableAvatar from "../common/CustomizableAvatar";
import Smartlend from "../../assets/SMARTLEND.png";
import MainAvatar from "../../assets/main-avatar.png";
import CustomButton from "../common/CustomButton";
import { PasswordIcon, ShowPasswordIcon } from "../common/IconComponents";
// import ReusableInput from "../common/ReusableInput";
import { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "./ReusableFormik/FormikControl";

import { Link, useNavigate } from "react-router-dom";

export default function UserSetup() {
  const navigate = useNavigate();
  // Password state
  const [showPassword, setShowPassword] = useState(false);
  const [passwordIcon, setPasswordIcon] = useState(<PasswordIcon />);

  //   This is to show or hide password
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
    setPasswordIcon(
      showPassword ? (
        <PasswordIcon />
      ) : (
        <ShowPasswordIcon className={"w-3 font-bold"} />
      )
    );
  };

  const initialValues = {
    password: "",
    confirmPassword: "",
  };
  // validation
  const validationSchema = Yup.object({
    // email: Yup.string().email("Invalid email format").required("Required"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters long")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
        "Password must contain one digit, one lowercase letter, one uppercase letter, and one special character"
      ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), ""], "Passwords must match")
      .required("Required"),
  });

  //   Form submission
  const onSubmit = (values) => {
    console.log("Form data", values);
    navigate("/dashboard");
  };

  return (
    <section className="container my-0  mx-auto">
      <div className=" py-6 px-4 md:p-8">
        <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
          {/* <div className=" min-h-full"> */}
          <CustomizableAvatar
            src={MainAvatar}
            customClass="px-1 lg:min-h-max"
          />
          {/* </div> */}

          <div className=" px-10 py-3 lg:col-span-2">
            <CustomizableAvatar src={Smartlend} avatarClass={"text-xs pb-3"} />
            <h3 className="text-2xl pt-3">Welcome, let's get you started!</h3>
            <p className="text-xs py-1 pb-3">
              Set up your password to get started with SMARTLEND
            </p>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {(formik) => {
                return (
                  <Form className="container w-9/12">
                    <FormikControl
                      control="input"
                      label="Work email address (required)"
                      type="email"
                      placeholder="e.g. idowu.oluwatofunmi9@gmail.com"
                      name="email"
                      className="bg-border-input w-full px-4 py-2 pr-10 text-xs md:text-sm rounded-md  shadow-md border-border-input placeholder-gray-500"
                      disabled
                    />

                    <div className="relative my-5">
                      <FormikControl
                        control="input"
                        label="Password (required)"
                        type={showPassword ? "text" : "password"}
                        placeholder="********"
                        name="password"
                      />
                      <span
                        onClick={toggleShowPassword}
                        className="absolute right-0  top-5 md:top-6   flex items-center pr-3 cursor-pointer"
                      >
                        {passwordIcon}
                      </span>
                    </div>

                    <div className="relative">
                      <FormikControl
                        control="input"
                        label="Confirm Password (required)"
                        type={showPassword ? "text" : "password"}
                        placeholder="********"
                        name="confirmPassword"
                      />
                      <span
                        onClick={toggleShowPassword}
                        className="absolute right-0  top-5 md:top-6   flex items-center pr-3 cursor-pointer"
                      >
                        {passwordIcon}
                      </span>
                    </div>

                    <button
                      type="submit"
                      className={
                        "bg-indigo-500 text-slate-50 border rounded  cursor-pointer my-7 py-1 px-14 hover:bg-indigo-600"
                      }
                      disabled={!formik.isValid}
                    >
                      Login
                    </button>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </section>
  );
}
